import React from 'react';
import { Car, Users, Package, DollarSign, LucideIcon } from 'lucide-react';

const InfoPanel: React.FC = () => {
  const stats: Array<{
    label: string;
    value: string;
    icon: LucideIcon;
    color: string;
    iconBg: string;
  }> = [
    { 
      label: '车辆总数', 
      value: '156', 
      icon: Car, 
      color: 'text-blue-600',
      iconBg: 'bg-blue-50'
    },
    { 
      label: '合格用户', 
      value: '2,847', 
      icon: Users, 
      color: 'text-green-600',
      iconBg: 'bg-green-50'
    },
    { 
      label: '订单数量', 
      value: '1,205', 
      icon: Package, 
      color: 'text-orange-600',
      iconBg: 'bg-orange-50'
    },
    { 
      label: '交易金额', 
      value: '$456.7K', 
      icon: DollarSign, 
      color: 'text-purple-600',
      iconBg: 'bg-purple-50'
    },
  ];

  return (
    <div className="bg-white mb-6 p-4">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">数据看板</h2>
      
      <div className="rounded-xl border bg-card text-card-foreground shadow">
        <div className="p-4">
          {/* <h3 className="text-lg font-semibold mb-4">平台统计</h3> */}
          <div className="grid grid-cols-2 gap-4">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            return (
              <div key={index} className="flex items-center gap-3">
                <div className="p-2 rounded-lg text-blue-600 bg-blue-50">
                  <IconComponent size={24} />
                </div>
                <div>
                  <p className="text-2xl font-bold">{stat.value}</p>
                  <p className="text-sm text-muted-foreground">{stat.label}</p>
                </div>
              </div>
            );
          })}
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;
